import { Breakpoint, useMediaQuery, useTheme } from "@mui/material";

const useIsMobile = (breakpoint: Breakpoint = "md") => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};

export default useIsMobile;
